
export default class CovidPatientAlarm {
    id=""
    date=new Date()
    covidPatient=""
    response1=""
    response2=""
    response3=""
    response4=""
    response5=""
    response6=""
    response7=""
    response8=""
    response9=""


}


// WEBPACK FOOTER //
// ./src/model/CovidPatientAlarm.js